import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    id: 'USER_CONFIGURATION',
};
var menuUserSlice = createSlice({
    name: 'menuUser',
    initialState: initialState,
    reducers: {
        clickMenuUser: function (state, action) {
            state.id = action.payload.id;
        },
    },
});
export var clickMenuUser = menuUserSlice.actions.clickMenuUser;
export default menuUserSlice.reducer;
